import React from 'react'
import styled from 'styled-components'

function LoanProcess() {
    return (
        <Container>
            <Content>
                <Caption>
                    <span>What's the process?</span>
                    <h2>The Loans have helped us move our business forward</h2>
                </Caption>
                <Steps>
                    <div className="step">
                        <div className="number">1</div>
                        <div className="step__caption">Apply</div>
                        <div className="step__details">Easily apply in minutes</div>
                    </div>
                    <div className="step">
                        <div className="number">2</div>
                        <div className="step__caption">Process</div>
                        <div className="step__details">Clear and transparent process</div>
                    </div>
                    <div className="step">
                        <div className="number">3</div>
                        <div className="step__caption">Support</div>
                        <div className="step__details">Support from real people</div>
                    </div>
                </Steps>
            </Content>
        </Container>
    )
}

const Container = styled.div`
    background: rgb(249, 250, 251);
    padding: 50px 20px;

    @media(min-width: 768px;){
        padding: 100px;
    }
`
const Content = styled.div`
    span{
        color: rgb(231, 60, 62);
    }
    h2{
        line-height: 35px;
    }
`
const Caption = styled.div`
    text-align: center;

    @media(min-width: 768px){
        width: 50%;
        margin: 0 auto;

        h2{
            line-height: 50.4px;
        }
    }
`
const Steps = styled.div`
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    @media(min-width: 768px){
        flex-direction: row;
        justify-content: space-around;
       
        .step{
            
            width: 25%;
            .number{
                position: absolute;
                top: 0;
                right: 35%;
            }
        }
    }
    .step{
        position: relative;
    }

    .number{
        font-size: 80px;
        font-weight: 500;
        color: rgba(231, 60, 62, 0.5);
        background: white;
        display: inline-block;
        padding: 30px 25px;
        border-radius: 50%;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
        position: relative;
        top: 90px;
        opacity: 0.3;
    }

    .step__caption{
        font-size: 20px;
        font-weight: 500;
        line-height: 100px;
        opacity: 1;
        
    }

    .step__details{
        font-size: 22px;
        font-weight: 500;
        line-height: 30.8px;
    }
`


export default LoanProcess
